module.exports = __webpack_public_path__ + "static/media/hund-teve.3fccdef6.svg";